// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"7b6a133d","496":"9d1d0b28"}[chunkId] + ".chunk.js";
};